const t = t => "fulfilled" === t.status,
  e = t => "rejected" === t.status;
export { t as isFulfilled, e as isRejected };
